(function () {
  'use strict';
  if (window.BNSCommerce) return;
  var config = window.BNS || {};
  var productData = new WeakMap();
  var mode = config.mode === 'wholesale' ? 'wholesale' : 'retail';
  try { var savedMode = localStorage.getItem('bns_mode'); if (savedMode === 'retail' || savedMode === 'wholesale') mode = savedMode; } catch (error) { /* Storage is optional. */ }
  var currency = config.currency || 'USD';
  var discountPercent = Number(config.discountPercent);
  if (config.discountPercent == null || !Number.isFinite(discountPercent) || discountPercent < 0 || discountPercent > 100) discountPercent = 25;
  var money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency });
  var root = (config.root || '/').replace(/\/?$/, '/');
  var cartBusy = false, latestCart = null, countGeneration = 0;

  function all(selector, scope) { return Array.from((scope || document).querySelectorAll(selector)); }
  function amount(cents) { return money.format(Number(cents || 0) / 100); }
  function canPrice() { return mode === 'retail' || config.wholesale === true; }
  function price(cents) { return mode === 'wholesale' && config.wholesale === true ? Math.round(Number(cents) * (1 - discountPercent / 100)) : Number(cents); }
  function positiveInteger(value) { if (typeof value === 'string' && !/^[0-9]+$/.test(value)) return null; var n = Number(value); return Number.isSafeInteger(n) && n >= 0 ? n : null; }
  function quantityValue(input, minimum, step, commit, blankIsZero) {
    if (commit && blankIsZero && input.value === '') input.value = '0';
    var value = positiveInteger(input.value), valid = value !== null && value >= minimum && value % step === 0;
    input.setCustomValidity(valid ? '' : step > 1 ? 'Enter whole pieces in multiples of ' + step + '.' : 'Enter a whole number of ' + minimum + ' or more.');
    if (valid) input.removeAttribute('aria-invalid'); else if (commit) input.setAttribute('aria-invalid', 'true');
    if (commit && valid) input.value = String(value);
    return valid ? value : null;
  }
  function packStep(packSize, casePack) {
    var a = packSize, b = casePack;
    while (b) { var remainder = a % b; a = b; b = remainder; }
    return packSize * casePack / a;
  }
  function dataFor(section) {
    if (productData.has(section)) return productData.get(section);
    if (!section) return null;
    var script = Array.from(section.children).find(function (node) { return node.matches('[data-product-json]'); }) || section.querySelector('[data-product-json]');
    if (!script) return null;
    try {
      var data = JSON.parse(script.textContent);
      data.packSize = Math.max(1, Number(data.packSize) || 1);
      data.casePack = Math.max(1, Number(data.casePack) || 1);
      if (hasCatalogueAuthority(data)) {
        data.packSize = Math.max(1, Number((data.specs || {}).retail_pack) || 1);
        data.casePack = 1;
        data.defaultOrderRun = [];
      }
      data.step = packStep(data.packSize, data.casePack);
      if (hasCatalogueAuthority(data)) data.product.variants = data.product.variants.filter(function (variant) { return catalogueVariantAllowed(data, variant); });
      productData.set(section, data);
      return data;
    } catch (error) { return null; }
  }
  function hasCatalogueAuthority(data) { return data.catalogueAuthority === 'AWD_CSV_2026-10-25' && (data.isApparel || (data.specs || {}).kind === 'apparel') && (data.specs || {}).kind !== 'drink'; }
  function dimensionKey(value) { return String(value || '').trim().toLowerCase().replace('colour', 'color').replace(/[\s_-]+/g, ''); }
  function catalogueVariantAllowed(data, variant) {
    if (!hasCatalogueAuthority(data)) return true;
    return Array.isArray(data.catalogueOptionTuples) && data.catalogueOptionTuples.some(function (tuple) {
      var names = optionNames(data);
      return names.length === variant.options.length && names.every(function (name, index) { var source = tuple[dimensionKey(name)]; return source != null && exactColour(source) === exactColour(variant.options[index]); });
    });
  }
  function galleryColour(data, value) {
    var aliases = data.catalogueColourAliases || {}, key = Object.keys(aliases).find(function (name) { return exactColour(name) === exactColour(value); });
    return exactColour(key && typeof aliases[key] === 'string' ? aliases[key] : value);
  }
  async function request(path, payload) {
    var options = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (payload) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(payload);
    }
    var response = await fetch(root + path, options);
    var result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'Shopify could not complete this request.');
    return result;
  }
  function paintCount(cart) {
    latestCart = cart;
    var generation = ++countGeneration;
    if (mode === 'retail') all('[data-cart-count]').forEach(function (node) { node.textContent = cart.item_count; });
    else fetch(root + 'cart?section_id=bns-cart-data', { credentials: 'same-origin' }).then(function (response) { if (!response.ok) throw new Error('Cart count unavailable.'); return response.text(); }).then(function (html) {
      var script = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-bns-cart-data]');
      if (!script) return;
      var data = JSON.parse(script.textContent);
      if (generation === countGeneration && mode === 'wholesale' && Number.isFinite(data.pieces)) all('[data-cart-count]').forEach(function (node) { node.textContent = data.pieces; });
    }).catch(function () { /* Keep the existing count when the native cart summary cannot load. */ });
    document.dispatchEvent(new CustomEvent('bns:cartchange', { detail: cart }));
  }
  async function refreshCount() { try { paintCount(await request('cart.js')); } catch (error) { /* Keep the server-rendered count on a network failure. */ } }
  function message(form, text, link) {
    var status = form.querySelector('[data-order-status], [data-cart-status]');
    if (!status) return;
    status.textContent = text;
    if (link) {
      var anchor = document.createElement('a');
      anchor.href = config.cartUrl || root + 'cart';
      anchor.textContent = ' View cart';
      status.appendChild(anchor);
    }
  }
  async function addItems(form, items) {
    if (form.dataset.busy === 'true' || !canPrice()) return false;
    if (!items.length) { message(form, 'Enter at least one quantity.'); return false; }
    var section = form.closest('[data-product-section]'), host = form.closest('[data-quick-order]');
    var sources = section ? [dataFor(section)] : host ? quickProducts(host) : [];
    if (sources.length && items.some(function (item) { return !sources.some(function (data) { return data && data.product.variants.some(function (variant) { return String(variant.id) === String(item.id) && variant.available && catalogueVariantAllowed(data, variant); }); }); })) {
      message(form, 'This option is no longer in the current catalogue. Choose a current colour and size.'); return false;
    }
    form.dataset.busy = 'true';
    var buttons = all('button[type="submit"]', form);
    buttons.forEach(function (button) { button.disabled = true; });
    message(form, 'Adding to your cart…');
    try {
      await request('cart/add.js', { items: items });
      message(form, 'Added to your cart.', true);
      buttons.forEach(function (button) { var label = button.textContent; button.textContent = 'ADDED ✓'; setTimeout(function () { if (button.isConnected) button.textContent = label; }, 1400); });
      all('[data-cart-count]').forEach(function (badge) { if (badge.animate) badge.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.28)' }, { transform: 'scale(1)' }], { duration: 400 }); });
      await refreshCount();
      return true;
    } catch (error) {
      message(form, error.message + ' Review your cart before trying again.', true);
      await refreshCount();
      return false;
    } finally {
      delete form.dataset.busy;
      buttons.forEach(function (button) { button.disabled = false; });
    }
  }
  function paint(scope) {
    document.documentElement.classList.add('bns-js');
    document.documentElement.classList.toggle('retail', mode === 'retail');
    document.documentElement.classList.toggle('wholesale', mode === 'wholesale');
    document.documentElement.classList.toggle('bns-wholesale-approved', config.wholesale === true);
    document.documentElement.dataset.mode = mode;
    config.mode = mode;
    all('[data-set-mode], [data-bns-mode]').forEach(function (node) {
      node.setAttribute('aria-current', String((node.dataset.setMode || node.dataset.bnsMode) === mode));
    });
    all('.bns-product-card .shot', scope).forEach(function (shot) { shot.classList.toggle('worn', !!shot.querySelector(mode === 'retail' ? '.onbody.bns-retail-only' : '.onbody.bns-wholesale-only')); });
    all('[data-money]', scope).forEach(function (node) { node.textContent = amount(price(node.dataset.retailPrice) / (mode === 'wholesale' ? Number(node.dataset.packDivisor || 1) : 1)); });
    (scope && scope.matches && scope.matches('[data-cart-section]') ? [scope] : all('[data-cart-section]', scope)).forEach(function (section) { section.classList.toggle('narrow', mode === 'retail'); });
    all('[data-price-sort]', scope).forEach(function (option) { option.hidden = !canPrice(); option.disabled = !canPrice(); });
    all('[data-piece-price]', scope).forEach(function (node) {
      var section = node.closest('[data-product-section]'), data = dataFor(section), variantPrice = section.querySelector('[data-variant-price]');
      if (data && variantPrice) node.textContent = amount(Number(variantPrice.dataset.retailPrice) / data.packSize);
    });
    scheduleCardHeights();
  }
  var cardHeightFrame = 0, cardGridWidths = new WeakMap();
  var cardGridObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      var width = entry.target.getBoundingClientRect().width;
      if (cardGridWidths.get(entry.target) !== width) { cardGridWidths.set(entry.target, width); scheduleCardHeights(); }
    });
  }) : null;
  function scheduleCardHeights() {
    if (cardHeightFrame) return;
    cardHeightFrame = requestAnimationFrame(function () {
      cardHeightFrame = 0;
      all('.rowgrid').forEach(function (grid) {
        if (!cardGridWidths.has(grid)) {
          cardGridWidths.set(grid, grid.getBoundingClientRect().width);
          if (cardGridObserver) cardGridObserver.observe(grid);
          grid.addEventListener('load', scheduleCardHeights, true);
        }
        var cards = Array.from(grid.children).filter(function (card) {
          return card.matches('.bns-product-card:not(.open)') && !card.hidden && card.getClientRects().length;
        });
        var bodies = cards.map(function (card) { return card.querySelector('.cbody'); });
        // Reset all measured bodies first, so earlier equalization cannot compound.
        bodies.forEach(function (body) { body.style.removeProperty('--bns-card-body-height'); });
        var sizes = cards.map(function (card, index) {
          var drawer = card.querySelector('.field');
          // A closing drawer still animates; it must never enlarge every other card.
          return { body: bodies[index].getBoundingClientRect().height,
            closed: card.getBoundingClientRect().height - (drawer ? drawer.getBoundingClientRect().height : 0) };
        });
        var tallest = sizes.reduce(function (height, size) { return Math.max(height, size.closed); }, 0);
        bodies.forEach(function (body, index) {
          body.style.setProperty('--bns-card-body-height', (sizes[index].body + tallest - sizes[index].closed) + 'px');
        });
      });
    });
  }
  window.addEventListener('resize', scheduleCardHeights);
  if (document.fonts) { document.fonts.ready.then(scheduleCardHeights); document.fonts.addEventListener('loadingdone', scheduleCardHeights); }
  function galleryItems(gallery) { return all('[data-media-id]', gallery).filter(function (node) { return node.dataset.galleryExcluded !== 'true'; }); }
  function showGalleryMedia(gallery, mediaId, focusThumbnail) {
    if (!gallery) return;
    var media = galleryItems(gallery);
    if (!media.length) {
      all('[data-media-id], [data-gallery-target], [data-gallery-controls]', gallery).forEach(function (node) { node.hidden = true; });
      delete gallery.dataset.activeMedia;
      return;
    }
    var photoStatus = gallery.querySelector('[data-wholesale-photo-status]');
    if (photoStatus && !gallery.dataset.missingColour) { photoStatus.hidden = true; photoStatus.textContent = ''; gallery.classList.remove('bns-colour-photo-missing'); }
    var selected = media.find(function (node) { return node.dataset.mediaId === String(mediaId); }) || media[0];
    gallery.classList.add('bns-gallery-enhanced');
    gallery.dataset.activeMedia = selected.dataset.mediaId;
    var selectedImage = selected.querySelector('img'); if (selectedImage) { if (!selectedImage.dataset.originalSrc) { selectedImage.dataset.originalSrc = selectedImage.src; selectedImage.dataset.originalSrcset = selectedImage.getAttribute('srcset') || ''; } else { selectedImage.src = selectedImage.dataset.originalSrc; if (selectedImage.dataset.originalSrcset) selectedImage.setAttribute('srcset', selectedImage.dataset.originalSrcset); } }
    all('[data-media-id]', gallery).forEach(function (node) {
      var active = node === selected;
      if (!active) {
        all('video, audio', node).forEach(function (player) { if (!player.paused) player.pause(); });
        all('model-viewer', node).forEach(function (model) { if (typeof model.pause === 'function') model.pause(); });
      }
      all('iframe', node).forEach(function (frame) {
        if (!active && frame.hasAttribute('src')) { frame.dataset.gallerySrc = frame.getAttribute('src'); frame.removeAttribute('src'); }
        else if (active && !frame.hasAttribute('src') && frame.dataset.gallerySrc) frame.setAttribute('src', frame.dataset.gallerySrc);
      });
      node.hidden = !active;
    });
    var thumbnail;
    all('[data-gallery-target]', gallery).forEach(function (link) {
      var active = link.dataset.galleryTarget === selected.dataset.mediaId;
      link.hidden = !media.some(function (node) { return node.dataset.mediaId === link.dataset.galleryTarget; });
      link.setAttribute('aria-current', String(active));
      if (active) thumbnail = link;
    });
    var controls = gallery.querySelector('[data-gallery-controls]');
    if (controls) controls.hidden = media.length < 2;
    var status = gallery.querySelector('[data-gallery-status]');
    if (status) status.textContent = (media.indexOf(selected) + 1) + ' / ' + media.length;
    if (thumbnail) {
      if (focusThumbnail) thumbnail.focus({ preventScroll: true });
      var rail = thumbnail.parentElement;
      if (thumbnail.offsetLeft < rail.scrollLeft) rail.scrollLeft = thumbnail.offsetLeft;
      else if (thumbnail.offsetLeft + thumbnail.offsetWidth > rail.scrollLeft + rail.clientWidth) rail.scrollLeft = thumbnail.offsetLeft + thumbnail.offsetWidth - rail.clientWidth;
    }
  }
  function nativeImageKey(source, data) {
    if (!source) return null;
    try {
      var url = new URL(source, location.origin), path = url.pathname;
      if (url.hostname === 'cdn.shopify.com') {
        var store = path.match(/^\/s\/files\/1\/(\d+\/\d+\/\d+)\//);
        if (!store || store[1].replace(/\//g, '').replace(/^0+/, '') !== String(data.shopId)) return null;
        path = '/' + path.slice(store[0].length);
      } else if (url.hostname === location.hostname || (data.shopDomains || []).indexOf(url.hostname) >= 0) path = path.replace(/^\/cdn\/shop\//, '/');
      else return null;
      if (!/^\/(files|products)\//.test(path)) return null;
      ['v', 'width', 'height'].forEach(function (key) { url.searchParams.delete(key); });
      return path + (url.searchParams.size ? '?' + url.searchParams.toString() : '');
    } catch (error) { return null; }
  }
  function nativeImage(data, source) {
    var key = nativeImageKey(source, data);
    return key && (data.nativeImages || []).find(function (image) { return nativeImageKey(image.src, data) === key && exactColour(String(image.alt || '').split('|')[0]) !== 'retained previous image'; }) || null;
  }
  function labelledColourImage(data, colour) {
    var wanted = exactColour(colour);
    return (data.nativeImages || []).find(function (image) {
      if (!nativeImage(data, image.src)) return false;
      var alt = String(image.alt || '').trim(), terminal = alt.match(/\bin\s+([^—|]+)$/i);
      if (alt.split('|').length === 3) return false;
      return galleryColour(data, alt) === wanted || terminal && galleryColour(data, terminal[1]) === wanted;
    }) || null;
  }
  var colourGalleryRoles = ['packaging', 'model front view', 'model back view', 'model side view', 'model detail close-up'];
  function exactColour(value) { return String(value || '').trim().toLowerCase(); }
  function colourChoices(data) {
    var index = optionNames(data).findIndex(function (name) { return name === 'color' || name === 'colour'; });
    return index < 0 ? 0 : new Set(data.product.variants.map(function (variant) { return exactColour(variant.options[index]); })).size;
  }
  function ownImages(data) { return (data.nativeImages || []).filter(function (image) { return String(image.alt || '').split('|').length !== 3 && nativeImage(data, image.src); }); }
  function colourGalleryImages(data, colour) {
    var wanted = exactColour(colour), index = optionNames(data).findIndex(function (name) { return name === 'color' || name === 'colour'; });
    if (!wanted || index < 0 || !data.style || !data.product.variants.some(function (variant) { return exactColour(variant.options[index]) === wanted; })) return [];
    var seen = new Set();
    return colourGalleryRoles.map(function (role) {
      var image = (data.nativeImages || []).find(function (item) {
        var fields = String(item.alt || '').split('|').map(function (value) { return value.trim(); });
        var key = nativeImageKey(item.src, data);
        return fields.length === 3 && normal(fields[0]) === normal(data.style) && galleryColour(data, fields[1]) === wanted && exactColour(fields[2]) === role && key && !seen.has(key) && nativeImage(data, item.src);
      });
      if (image) { seen.add(nativeImageKey(image.src, data)); return {src:image.src, alt:image.alt, role:role}; }
      return null;
    }).filter(Boolean);
  }
  function nativeColourImage(data, source, colour) {
    var image = nativeImage(data, source);
    if (!image) return null;
    var fields = String(image.alt || '').split('|').map(function (value) { return value.trim(); });
    if (fields.length === 3 && (normal(fields[0]) !== normal(data.style) || galleryColour(data, fields[1]) !== exactColour(colour))) return null;
    var index = optionNames(data).findIndex(function (name) { return name === 'color' || name === 'colour'; });
    var knownColours = data.product.variants.map(function (variant) { return exactColour(variant.options[index]); });
    var label = galleryColour(data, image.alt);
    if (knownColours.indexOf(label) >= 0 && label !== exactColour(colour)) return null;
    return image;
  }
  function colourImage(data, colour, selectedVariant) {
    var colourSet = data.isApparel ? colourGalleryImages(data, colour) : [];
    if (colourSet.length) return colourSet[0].src;
    var index = optionNames(data).findIndex(function (name) { return name === 'color' || name === 'colour'; });
    if (hasCatalogueAuthority(data) && index < 0) {
      var attachedVariant = selectedVariant || data.product.variants.find(function (item) { return item.featured_image; });
      var attachedImage = attachedVariant && attachedVariant.featured_image && nativeColourImage(data, attachedVariant.featured_image.src, '');
      return attachedImage ? attachedImage.src : null;
    }
    if (data.isApparel && selectedVariant && selectedVariant.featured_image && exactColour(selectedVariant.options[index]) === exactColour(colour)) {
      var selectedImage = nativeColourImage(data, selectedVariant.featured_image.src, colour);
      if (selectedImage) return selectedImage.src;
    }
    var variant = index < 0 ? null : data.product.variants.find(function (item) { return item.featured_image && exactColour(item.options[index]) === exactColour(colour) && (!data.isApparel || nativeColourImage(data, item.featured_image.src, colour)); });
    if (variant) return data.isApparel ? nativeColourImage(data, variant.featured_image.src, colour).src : variant.featured_image.src;
    var images = data.colourImages || {}, key = Object.keys(images).find(function (name) { return galleryColour(data, name) === exactColour(colour); });
    if (data.isApparel) {
      var attached = nativeColourImage(data, key && images[key], colour);
      var labelled = attached || labelledColourImage(data, colour);
      return labelled ? labelled.src : null;
    }
    return key ? images[key] : null;
  }
  function showProductColour(section, data, colour, variant, initial) {
    var images = colourGalleryImages(data, colour), roles = images.map(function (image) { return image.role; });
    // Third-party brands carry no packaging shot, so packaging only counts as missing when the product has one somewhere.
    var packaged = (data.nativeImages || []).some(function (item) { var fields = String(item.alt || '').split('|'); return fields.length === 3 && exactColour(fields[2]) === 'packaging'; });
    var missing = colourGalleryRoles.filter(function (role) { return roles.indexOf(role) < 0 && (packaged || role !== 'packaging'); });
    var retail = section.querySelector('.rgal'), gallery = section.querySelector('.gal[data-gallery]');
    var notice = '';
    if (images.length) {
      if (missing.length) notice = (colour || 'This item') + ': ' + missing.join(', ') + ' not available yet.';
    } else if (colourChoices(data) <= 1 && !hasCatalogueAuthority(data) && ownImages(data).length) {
      // With one colour (or none) and no AWD catalogue rule, unlabelled product photos cannot show a wrong colour.
      images = ownImages(data);
    } else {
      var source = colourImage(data, colour, variant), fallback = source && nativeColourImage(data, source, colour);
      if (fallback) images = [{src:fallback.src, alt:fallback.alt}];
      notice = fallback ? 'The five-view photo set for ' + (colour || 'this item') + ' is incomplete. Showing the available product image.' : 'A photo for ' + (colour || 'this item') + ' is not available yet.';
    }
    section.dataset.galleryColour = colour || '';
    all('[data-wholesale-colour]', section).forEach(function (button) { button.setAttribute('aria-current', String(exactColour(button.dataset.wholesaleColour) === exactColour(colour))); });
    var label = section.querySelector('[data-wholesale-colour-label]'); if (label) label.textContent = String(colour || '').toUpperCase();
    if (retail) {
      var shots = all('.rshot', retail);
      var ordered = images.map(function (image) {
        return shots.find(function (shot) { var photo = shot.querySelector('img'); return photo && nativeImageKey(photo.dataset.originalSrc || photo.src, data) === nativeImageKey(image.src, data); });
      }).filter(Boolean);
      shots.forEach(function (shot) {
        var photo = shot.querySelector('img');
        if (photo && photo.dataset.originalSrc) { photo.src = photo.dataset.originalSrc; photo.alt = photo.dataset.originalAlt || photo.alt; if (photo.dataset.originalSrcset) photo.setAttribute('srcset', photo.dataset.originalSrcset); else photo.removeAttribute('srcset'); }
        if (photo) { photo.hidden = false; photo.removeAttribute('data-retail-colour-image'); }
        shot.hidden = ordered.indexOf(shot) < 0;
      });
      ordered.forEach(function (shot) { retail.appendChild(shot); });
      if (ordered[0]) ordered[0].querySelector('img').setAttribute('data-retail-colour-image', '');
      var retailStatus = retail.querySelector('[data-retail-photo-status]');
      if (retailStatus) { retailStatus.textContent = notice; retailStatus.hidden = !notice; }
      retail.classList.toggle('bns-colour-photo-missing', !!notice);
    }
    if (gallery) {
      var nodes = all('[data-media-id]', gallery), stage = gallery.querySelector('[data-gallery-stage]'), rail = gallery.querySelector('[data-gallery-thumbs]');
      var allowed = images.map(function (image) {
        return nodes.find(function (node) { var photo = node.querySelector('img'); return photo && nativeImageKey(photo.dataset.originalSrc || photo.src, data) === nativeImageKey(image.src, data); });
      }).filter(Boolean);
      nodes.forEach(function (node) { node.dataset.galleryExcluded = String(allowed.indexOf(node) < 0); });
      allowed.forEach(function (node) {
        if (stage) stage.appendChild(node);
        var thumb = all('[data-gallery-target]', gallery).find(function (item) { return item.dataset.galleryTarget === node.dataset.mediaId; });
        if (thumb && rail) rail.appendChild(thumb);
      });
      delete gallery.dataset.missingColour;
      showGalleryMedia(gallery, allowed[0] && allowed[0].dataset.mediaId);
      if (notice) gallery.dataset.missingColour = colour || 'unselected';
      var status = gallery.querySelector('[data-wholesale-photo-status]');
      if (status) { status.textContent = notice; status.hidden = !notice; }
      gallery.classList.toggle('bns-colour-photo-missing', !!notice);
    }
  }
  function optionNames(data) { return (data.product.options || []).map(function (option) { return String(option.name || option).toLowerCase(); }); }
  function galleryFileBase(url) {
    var base = String(url || '').split('/').pop().split('?')[0];
    return base.replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?=\.)/i, '').replace(/_\d+x(\d+)?(?=\.)/, '');
  }
  function galleryMediaByFile(nodes, variant, data) {
    var source = variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src || variant.featured_image && variant.featured_image.src || '';
    if (data.isApparel) {
      var attached = nativeImage(data, source);
      return attached && nodes.find(function (node) {
        var image = node.querySelector('img');
        return image && nativeImageKey(image.dataset.originalSrc || image.getAttribute('src'), data) === nativeImageKey(attached.src, data);
      }) || null;
    }
    var want = galleryFileBase(source);
    if (!want) return null;
    return nodes.find(function (node) {
      var img = node.querySelector('img');
      if (!img) return false;
      return galleryFileBase(img.currentSrc || img.getAttribute('src')) === want;
    }) || null;
  }
  function selectVariant(section, variant, keepUnselected, updatePhoto) {
    var data = dataFor(section), form = section.querySelector('[data-retail-form]');
    if (!data || !form) return;
    var select = form.querySelector('[data-variant-select]'), add = form.querySelector('[data-retail-add]');
    if (!add.dataset.label) add.dataset.label = 'ADD TO CART';
    var incomplete = keepUnselected === true;
    add.disabled = !incomplete && (!variant || !variant.available);
    add.textContent = incomplete ? 'SELECT A SIZE' : !variant ? 'Unavailable' : variant.available ? add.dataset.label : 'Sold out';
    select.value = variant ? String(variant.id) : '';
    if (variant) {
      all('[data-variant-price]', section).forEach(function (node) { node.dataset.retailPrice = variant.price; node.textContent = amount(variant.price); });
      all('[data-piece-price]', section).forEach(function (node) { node.textContent = amount(variant.price / data.packSize); });
      all('[data-option-value]', form).forEach(function (button) { button.setAttribute('aria-current', String(variant.options[Number(button.dataset.optionIndex)] === button.dataset.optionValue)); });
      if (!(window.Shopify && window.Shopify.designMode)) { var url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
    }
    var names = optionNames(data), colourIndex = names.findIndex(function (name) { return name === 'color' || name === 'colour'; });
    var colourButton = form.querySelector('[data-option-index="' + colourIndex + '"][aria-current="true"]');
    var colour = variant ? variant.options[colourIndex] : colourButton && colourButton.dataset.optionValue;
    var label = form.querySelector('[data-retail-colour-label]'); if (label) label.textContent = (colour || '').toUpperCase();
    var changePhoto = !data.isApparel || updatePhoto !== false;
    if (changePhoto) {
      if (data.isApparel) showProductColour(section, data, colour, variant);
      else { var image = section.querySelector('[data-retail-colour-image]'), source = colourImage(data, colour, variant); if (image && source) { image.src = source; image.removeAttribute('srcset'); } }
    }
    all('[data-option-name="size"] button', form).forEach(function (button) {
      button.disabled = !data.product.variants.some(function (candidate) { return candidate.available && candidate.options[Number(button.dataset.optionIndex)] === button.dataset.optionValue && (colourIndex < 0 || candidate.options[colourIndex] === colour); });
    });
    if (!data.isApparel && variant && (variant.featured_media || variant.featured_image)) {
      var galleryNodes = all('.bns-media', section).filter(function (node) { return node.dataset.mediaId && node.dataset.mediaId === node.dataset.imageId; });
      if (!galleryNodes.length) galleryNodes = all('.bns-media', section);
      var media = galleryNodes.find(function (node) { return variant.featured_media && node.dataset.mediaId === String(variant.featured_media.id) || variant.featured_image && node.dataset.imageId === String(variant.featured_image.id); });
      if (!media) media = galleryMediaByFile(galleryNodes, variant, data);
      if (media) { var gallery = media.closest('[data-gallery]'); if (gallery) showGalleryMedia(gallery, media.dataset.mediaId); }
    }
    message(form, !variant && !incomplete ? 'This option combination is unavailable.' : '');
  }
  function seedMatrix(form) {
    if (form.dataset.initialized) return;
    form.dataset.initialized = 'true';
    var data = dataFor(form.closest('[data-product-section]'));
    if (!data || !Array.isArray(data.defaultOrderRun) || data.quoteOnly) return;
    var names = optionNames(data), ci = names.findIndex(function (name) { return name === 'color' || name === 'colour'; }), si = names.indexOf('size');
    if (ci < 0 || si < 0) return;
    data.defaultOrderRun.forEach(function (line) {
      var pieces = positiveInteger(line.pieces);
      if (!pieces || pieces % data.step !== 0) return;
      var variants = data.product.variants.filter(function (variant) { return normal(variant.options[ci]) === normal(line.colour) && normal(variant.options[si]) === normal(line.size); });
      if (variants.length !== 1 || !variants[0].available) return;
      var input = all('input[data-variant-id]', form).find(function (node) { return node.dataset.variantId === String(variants[0].id); });
      if (input && !input.disabled && Number(input.value) === 0) input.value = pieces;
    });
  }
  function recalcMatrix(form, commit) {
    commit = commit === true;
    var data = dataFor(form.closest('[data-product-section]'));
    if (!data) return;
    var pieces = 0, total = 0, valid = true;
    all('input[data-variant-id]', form).forEach(function (input) {
      if (input.disabled) return;
      var quantity = quantityValue(input, 0, data.step, commit, true);
      var okay = quantity !== null;
      if (!okay) valid = false;
      input.classList.toggle('has', quantity > 0);
      if (quantity !== null) { pieces += quantity; total += quantity / data.packSize * price(input.dataset.retailPrice); }
    });
    form.querySelector('[data-matrix-pieces]').textContent = pieces.toLocaleString();
    var subtotal = form.querySelector('[data-matrix-total]');
    if (subtotal) subtotal.textContent = amount(total);
    var button = form.querySelector('[data-matrix-add]');
    if (button) button.disabled = !valid || pieces === 0 || form.dataset.busy === 'true';
    updateRunbar(form, pieces, total);
  }
  function fillRow(row, form) {
    var data = dataFor(form.closest('[data-product-section]'));
    var inputs = all('input.qty', row);
    var curve = form.querySelector('[data-curve][aria-pressed="true"]');
    inputs.forEach(function (input, index) {
      var weight = !curve || curve.dataset.curve === 'flat' || inputs.length < 3 ? 1 : Math.max(1, Math.round(3 - Math.abs(index - Math.min(2, (inputs.length - 1) / 2))));
      if (curve && curve.dataset.curve === 'core' && index > 3) weight = 0;
      if (!input.disabled) input.value = weight * data.step;
    });
    row.dataset.curved = 'true';
    recalcMatrix(form);
  }
  function quickProducts(host) {
    return all('[data-quick-product]', host).map(dataFor).filter(Boolean).sort(function (a, b) { return Number((a.specs || {}).curated_order || 0) - Number((b.specs || {}).curated_order || 0); });
  }
  function newQuickRow(host) {
    var row = document.createElement('tr'); row.dataset.quickRow = '';
    ['style', 'colour', 'size', 'quantity', 'total', 'remove'].forEach(function (field) {
      var cell = document.createElement('td'), node;
      if (field === 'style' || field === 'colour' || field === 'size') {
        node = document.createElement('select'); node.dataset['quick' + field.charAt(0).toUpperCase() + field.slice(1)] = '';
        node.setAttribute('aria-label', field === 'style' ? 'Style' : field === 'colour' ? 'Colour' : 'Size');
        node.add(new Option(field === 'style' ? 'Style…' : '—', '')); node.disabled = field !== 'style';
        if (field === 'style') quickProducts(host).forEach(function (data) { node.add(new Option(data.style + ' — ' + data.displayName, String(data.product.id))); });
      } else if (field === 'quantity') { node = document.createElement('input'); node.type = 'text'; node.inputMode = 'numeric'; node.pattern = '[0-9]*'; node.autocomplete = 'off'; node.enterKeyHint = 'next'; node.value = '0'; node.dataset.quickQuantity = ''; node.dataset.quantityStep = '1'; node.setAttribute('aria-label', 'Quantity in pieces'); }
      else if (field === 'total') { node = document.createElement('span'); node.dataset.quickTotal = ''; cell.className = 'num'; }
      else { node = document.createElement('button'); node.type = 'button'; node.className = 'qorow-del'; node.dataset.quickRemove = ''; node.textContent = '×'; node.setAttribute('aria-label', 'Remove empty row'); }
      cell.appendChild(node); row.appendChild(cell);
    });
    host.querySelector('[data-quick-body]').appendChild(row); syncQuickRow(row); return row;
  }
  function syncQuickRow(row) {
    var host = row.closest('[data-quick-order]'), id = row.querySelector('[data-quick-style]').value;
    var data = quickProducts(host).find(function (item) { return String(item.product.id) === id; });
    var colour = row.querySelector('[data-quick-colour]'), size = row.querySelector('[data-quick-size]');
    if (row.dataset.productId !== id) {
      row.dataset.productId = id; colour.replaceChildren(new Option('—', '')); size.replaceChildren(new Option('—', ''));
      if (data) {
        var names = optionNames(data), ci = names.findIndex(function (name) { return name === 'color' || name === 'colour'; }), si = names.indexOf('size');
        [colour, size].forEach(function (select, index) {
          var position = index === 0 ? ci : si;
          var values = position < 0 ? ['Default'] : Array.from(new Set(data.product.variants.map(function (variant) { return variant.options[position]; })));
          select.replaceChildren(); values.forEach(function (value) { select.add(new Option(value, value)); });
        });
      }
    }
    colour.disabled = size.disabled = !data;
    row.querySelector('[data-quick-remove]').setAttribute('aria-label', data ? 'Remove row: ' + data.style + ' ' + data.displayName : 'Remove empty row');
    if (!data) return null;
    var names = optionNames(data), ci = names.findIndex(function (name) { return name === 'color' || name === 'colour'; }), si = names.indexOf('size');
    var candidates = data.product.variants.filter(function (variant) { return (ci < 0 || variant.options[ci] === colour.value) && (si < 0 || variant.options[si] === size.value); });
    var variant = candidates.length === 1 ? candidates[0] : null;
    row.dataset.variantId = variant ? variant.id : ''; row.dataset.packSize = data.packSize; row.dataset.style = data.style;
    return { data: data, variant: variant };
  }
  function recalcQuick(form, commit) {
    commit = commit === true;
    var any = false, valid = true;
    all('[data-quick-row]', form).forEach(function (row) {
      var match = syncQuickRow(row), input = row.querySelector('[data-quick-quantity]');
      input.disabled = !!(match && match.data.quoteOnly);
      if (input.disabled) { input.setCustomValidity(''); input.removeAttribute('aria-invalid'); row.querySelector('[data-quick-total]').textContent = 'QUOTE'; return; }
      var step = match ? (mode === 'wholesale' ? match.data.step : match.data.packSize) : 1;
      input.dataset.quantityStep = step;
      var quantity = quantityValue(input, 0, step, commit, true);
      var okay = quantity !== null && (quantity === 0 || match && match.variant && match.variant.available && !match.data.quoteOnly && quantity % step === 0);
      input.setCustomValidity(okay ? '' : 'Choose an available colour and size and enter pieces in multiples of ' + step + '.');
      if (okay) input.removeAttribute('aria-invalid'); else if (commit) input.setAttribute('aria-invalid', 'true');
      if (!okay) valid = false;
      if (quantity > 0) any = true;
      row.querySelector('[data-quick-total]').textContent = canPrice() ? amount(match && match.variant ? (quantity || 0) / match.data.packSize * price(match.variant.price) : 0) : '—';
    });
    form.querySelector('[data-quick-add]').disabled = !valid || !any || form.dataset.busy === 'true';
  }
  function csvRows(text) {
    text = String(text).replace(/^\uFEFF/, '');
    var delimiter = text.split(/\r?\n/)[0].indexOf('\t') >= 0 ? '\t' : ',';
    var rows = [], row = [], field = '', quoted = false;
    for (var i = 0; i < text.length; i++) {
      var character = text[i];
      if (character === '"') {
        if (quoted && text[i + 1] === '"') { field += '"'; i++; }
        else quoted = !quoted;
      } else if (!quoted && character === delimiter) { row.push(field.trim()); field = ''; }
      else if (!quoted && (character === '\n' || character === '\r')) {
        if (character === '\r' && text[i + 1] === '\n') i++;
        row.push(field.trim());
        if (row.some(Boolean)) rows.push(row);
        row = []; field = '';
      } else field += character;
    }
    if (quoted) throw new Error('A quoted field is not closed. Check your CSV and try again.');
    row.push(field.trim());
    if (row.some(Boolean)) rows.push(row);
    if (rows.length > 501) throw new Error('Import up to 500 order rows at a time.');
    return rows;
  }
  function normal(value) { return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function importQuick(host, text) {
    var status = host.querySelector('[data-import-status]'), form = host.querySelector('[data-quick-form]'); status.hidden = false;
    if (host.dataset.loading === 'true') { status.textContent = 'The catalogue is loading. Try importing again when all styles have loaded.'; return; }
    try {
      var rows = csvRows(text), products = quickProducts(host), errors = [], rejected = [], imported = 0;
      var header = rows.length && normal(rows[0][0]) === 'STYLE'; if (header) rows.shift();
      if (!rows.length) throw new Error('Paste at least one order row.');
      rows.forEach(function (fields, index) {
        try {
          if (fields.length !== 4) throw new Error('Use four columns: style, colour, size, qty.');
          var matches = products.filter(function (data) { return normal(data.style) === normal(fields[0]); });
          if (matches.length !== 1) throw new Error('Style "' + fields[0] + '" is unknown or ambiguous.');
          var data = matches[0], names = optionNames(data), ci = names.findIndex(function (name) { return name === 'color' || name === 'colour'; }), si = names.indexOf('size');
          var variants = data.product.variants.filter(function (variant) { return (ci < 0 || normal(variant.options[ci]) === normal(fields[1])) && (si < 0 || normal(variant.options[si]) === normal(fields[2])); });
          if (data.quoteOnly) throw new Error('This style requires a quote.');
          if (variants.length !== 1) throw new Error('The colour and size do not identify one variant.');
          if (!variants[0].available) throw new Error('This variant is unavailable.');
          var quantity = /^\d+$/.test(fields[3]) ? positiveInteger(fields[3]) : null, step = mode === 'wholesale' ? data.step : data.packSize;
          if (!quantity || quantity % step !== 0) throw new Error('Enter pieces in multiples of ' + step + '.');
          var row = all('[data-quick-row]', form).find(function (item) { return !item.querySelector('[data-quick-style]').value && Number(item.querySelector('[data-quick-quantity]').value) === 0; }) || newQuickRow(host);
          row.querySelector('[data-quick-style]').value = data.product.id; syncQuickRow(row);
          if (ci >= 0) row.querySelector('[data-quick-colour]').value = variants[0].options[ci];
          if (si >= 0) row.querySelector('[data-quick-size]').value = variants[0].options[si];
          row.querySelector('[data-quick-quantity]').value = quantity; imported++;
        } catch (error) { errors.push('Line ' + (index + (header ? 2 : 1)) + ': ' + error.message); rejected.push(fields.map(function (field) { return '"' + field.replace(/"/g, '""') + '"'; }).join(',')); }
      });
      recalcQuick(form); host.querySelector('[data-quick-paste]').value = rejected.join('\n');
      status.textContent = imported + ' rows added.';
      if (errors.length) { var list = document.createElement('ul'); errors.forEach(function (error) { var item = document.createElement('li'); item.textContent = error; list.appendChild(item); }); status.appendChild(list); }
    } catch (error) { status.textContent = error.message; }
  }
  async function updateCart(section, payload) {
    if (cartBusy) return;
    cartBusy = true;
    var form = section.querySelector('[data-cart-form]');
    all('button, input', form).forEach(function (node) { node.disabled = true; });
    message(form, 'Updating your cart…');
    try {
      var result = await request(payload.updates ? 'cart/update.js' : 'cart/change.js', Object.assign(payload, { sections: [section.dataset.sectionId], sections_url: config.cartUrl || root + 'cart' }));
      paintCount(result);
      var html = result.sections && result.sections[section.dataset.sectionId];
      if (!html) throw new Error('Your cart was updated. Refresh this page to see the current quantities.');
      var parsed = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-section]');
      if (!parsed) throw new Error('Your cart was updated. Refresh this page to see it.');
      section.replaceWith(parsed);
      init(parsed);
    } catch (error) { message(form, error.message); }
    finally { cartBusy = false; all('button, input', form).forEach(function (node) { node.disabled = false; }); }
  }
  function commitCartQuantity(input) {
    var quantity = quantityValue(input, 0, 1, true, false), section = input.closest('[data-cart-section]');
    if (quantity === null) { message(section.querySelector('[data-cart-form]'), input.validationMessage); input.reportValidity(); return; }
    if (input.closest('[data-cart-line]').dataset.catalogueAllowed === 'false' && quantity > 0) { message(section.querySelector('[data-cart-form]'), 'Remove this retired option and choose a current catalogue option before checkout.'); return; }
    updateCart(section, { id: input.closest('[data-line-key]').dataset.lineKey, quantity: quantity });
  }
  function initLogin(scope) {
    all('[data-login-card]', scope).forEach(function (card) {
      var password = card.querySelector('input[type="password"][name="customer[password]"]');
      var toggle = card.querySelector('[data-login-show]');
      if (password && toggle && !toggle.dataset.bound) {
        toggle.dataset.bound = 'true';
        toggle.addEventListener('click', function () {
          var show = password.type === 'password';
          password.type = show ? 'text' : 'password';
          toggle.textContent = show ? 'HIDE' : 'SHOW';
          toggle.setAttribute('aria-pressed', String(show));
          password.focus({ preventScroll: true });
        });
      }
      var email = card.querySelector('input[name="customer[email]"]');
      var remember = card.querySelector('[data-login-remember]');
      var form = card.querySelector('#signinform');
      if (email && remember && form && !form.dataset.loginBound) {
        form.dataset.loginBound = 'true';
        try {
          var saved = localStorage.getItem('bns_login_email');
          if (saved && !email.value) email.value = saved;
          if (saved) remember.checked = true;
        } catch (error) { /* Storage is optional. */ }
        form.addEventListener('submit', function () {
          try {
            if (remember.checked && email.value) localStorage.setItem('bns_login_email', email.value);
            else if (!remember.checked) localStorage.removeItem('bns_login_email');
          } catch (error) { /* Storage is optional. */ }
        });
      }
      var forgot = card.querySelector('[data-login-forgot]');
      var recovery = card.querySelector('[data-login-recovery]');
      if (forgot && recovery && !forgot.dataset.bound) {
        forgot.dataset.bound = 'true';
        forgot.addEventListener('click', function () {
          recovery.open = true;
          var field = recovery.querySelector('input[type="email"]');
          if (field) {
            if (email && email.value && !field.value) field.value = email.value;
            if (field.focus) field.focus({ preventScroll: false });
          }
          if (recovery.scrollIntoView) recovery.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        });
      }
    });
  }
  var runForm = null, runObserver = null;
  function updateRunbar(form, pieces, total) {
    if (pieces > 0) runForm = form; else if (runForm === form) runForm = null;
    var bar = document.getElementById('runbar');
    if (!bar) { bar = document.createElement('div'); bar.id = 'runbar'; document.body.appendChild(bar); }
    if (runForm !== form) { if (!runForm) bar.classList.remove('on'); return; }
    bar.replaceChildren();
    var inner = document.createElement('div'); inner.className = 'wrap rbin';
    var stat = document.createElement('span'); stat.className = 'rbstat';
    var count = document.createElement('b'); count.textContent = pieces.toLocaleString(); stat.append(count, ' PCS'); inner.appendChild(stat);
    if (config.wholesale) { var subtotal = document.createElement('span'); subtotal.className = 'rbstat rbsub'; subtotal.textContent = amount(total); inner.appendChild(subtotal); }
    var action = document.createElement(config.wholesale ? 'button' : 'a'); action.className = 'rbgo';
    if (config.wholesale) { action.type = 'button'; action.dataset.runAdd = ''; action.textContent = 'ADD ALL TO CART'; }
    else {
      if (config.signedIn) {
        action.href = (config.routes && config.routes.login) || root + 'account/login';
        action.textContent = 'SIGN IN TO PRICE';
      } else {
        action.href = config.wholesaleSignupUrl || root + 'pages/register';
        action.textContent = 'SIGN UP TO PRICE';
      }
    }
    inner.appendChild(action); bar.appendChild(inner);
    if (runObserver) runObserver.disconnect();
    if (!window.IntersectionObserver) return;
    var own = true, foot = false, totals = form.querySelector('.totals'), footer = document.querySelector('footer');
    runObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.target === totals) own = entry.isIntersecting; if (entry.target === footer) foot = entry.isIntersecting; });
      var card = runForm && runForm.closest('.card');
      bar.classList.toggle('on', !!(mode === 'wholesale' && runForm && runForm.isConnected && card && card.classList.contains('open') && !own && !foot));
    }, { rootMargin: '0px 0px -78px 0px' });
    if (totals) runObserver.observe(totals); if (footer) runObserver.observe(footer);
  }
  function nativeColours(data) {
    var names = optionNames(data), index = names.findIndex(function (name) { return name === 'color' || name === 'colour'; });
    if (index < 0 || (data.specs || {}).kind === 'drink') return [];
    var swatches = data.colourSwatches || {};
    return Array.from(new Set(data.product.variants.map(function (variant) { return variant.options[index]; }))).map(function (name) {
      var key = Object.keys(swatches).find(function (value) { return normal(value) === normal(name); }), swatch = swatches[key] || {};
      return { name: name, family: swatch.family || name, hex: /^#[\da-f]{3,8}$/i.test(swatch.hex || '') ? swatch.hex : '#dedbd5' };
    });
  }
  function familyKey(value) { return String(value || '').trim().toLowerCase().replace(/[\s_-]+/g, ' ').replace(/\bgr[ae]ys?\b/g, 'gray'); }
  function catalogueCards(host) { var grid = host.querySelector('[data-catalogue-grid]'); if (!grid) return []; var cards = Array.from(grid.children).filter(function (node) { return node.hasAttribute('data-catalogue-card'); }); cards.forEach(function (node, index) { if (!node.dataset.pos) node.dataset.pos = index; }); return cards; }
  function initCatalogue(host) {
    if (!host.dataset.filtersInitialized) {
      var params = new URLSearchParams(location.search);
      host.dataset.filterColour = params.get('colour') || params.get('color') || params.get('filter.v.option.color') || params.get('filter.v.option.colour') || '';
      host.dataset.filterSize = params.get('size') || '';
      host.dataset.filterQuery = params.get('q') || '';
      host.dataset.filtersInitialized = 'true';
    }
    var families = new Map(), sizes = new Map();
    var facets = catalogueCards(host).map(function (card) {
      var data = dataFor(card), index = optionNames(data).indexOf('size');
      return { colours: nativeColours(data), sizes: index < 0 ? [] : Array.from(new Set(data.product.variants.map(function (variant) { return variant.options[index]; }))) };
    });
    var globalData = document.querySelector('[data-bns-search-catalogue]');
    if (globalData) {
      try {
        var catalogue = JSON.parse(globalData.textContent);
        if (Array.isArray(catalogue.products) && catalogue.products.length && catalogue.products[0].sizes) facets = catalogue.products.filter(function (product) { return !product.material; }).map(function (product) {
          var swatches = product.colourSwatches || {};
          return { sizes: product.sizes || [], colours: (product.colours || []).map(function (name) { var key = Object.keys(swatches).find(function (key) { return normal(key) === normal(name); }), swatch = swatches[key] || {}; return { name: name, family: swatch.family || name, hex: /^#[\da-f]{3,8}$/i.test(swatch.hex || '') ? swatch.hex : '#dedbd5' }; }) };
        });
      } catch (error) { /* Section-only responses can use their own native facets. */ }
    }
    facets.forEach(function (item) {
      item.colours.forEach(function (colour) { var key = familyKey(colour.family), family = families.get(key) || { name: colour.family, hex: colour.hex, count: 0 }; family.count++; families.set(key, family); });
      item.sizes.forEach(function (size) { sizes.set(size, (sizes.get(size) || 0) + 1); });
    });
    var sortedFamilies = Array.from(families.values()).sort(function (a, b) { return b.count - a.count; });
    var familyHost = host.querySelector('[data-colour-filters]');
    if (familyHost) { familyHost.replaceChildren(); sortedFamilies.forEach(function (family) {
      var button = document.createElement('button'); button.type = 'button'; button.className = 'fbtn'; button.dataset.filterColour = family.name;
      var swatch = document.createElement('i'); swatch.style.background = family.hex; var count = document.createElement('u'); count.textContent = family.count;
      button.append(swatch, family.name, count); familyHost.appendChild(button);
    }); }
    var sizeHost = host.querySelector('[data-size-filters]');
    if (sizeHost) { sizeHost.replaceChildren(); Array.from(sizes.entries()).sort(function (a, b) { return b[1] - a[1]; }).slice(0, 10).forEach(function (size) {
      var button = document.createElement('button'); button.type = 'button'; button.className = 'fbtn'; button.dataset.filterSize = size[0]; button.textContent = size[0]; sizeHost.appendChild(button);
    }); }
    var familyGrid = host.querySelector('[data-colour-families]');
    if (familyGrid) { familyGrid.replaceChildren(); sortedFamilies.forEach(function (family) {
      var link = document.createElement('a'); link.className = 'sw'; link.href = root + 'pages/colour?colour=' + encodeURIComponent(family.name);
      var swatch = document.createElement('i'); swatch.style.background = family.hex;
      var label = document.createElement('span'), title = document.createElement('b'); title.textContent = family.name.toUpperCase(); label.append(title, family.count + ' colourways'); link.append(swatch, label); familyGrid.appendChild(link);
    }); }
    filterCatalogue(host);
  }
  function filterCatalogue(host) {
    var colour = familyKey(host.dataset.filterColour), size = host.dataset.filterSize || '', query = normal(host.dataset.filterQuery);
    var cards = catalogueCards(host), visible = 0, select = host.querySelector('[data-catalogue-sort]'), sort = select ? select.value : '';
    if (sort === 'price' && !canPrice()) sort = '';
    cards.forEach(function (card) {
      var data = dataFor(card), names = optionNames(data), sizeIndex = names.indexOf('size');
      var matches = (!colour || nativeColours(data).some(function (item) { return familyKey(item.family) === colour || familyKey(item.name) === colour; })) && (!size || data.product.variants.some(function (variant) { return variant.options[sizeIndex] === size; })) && (!query || normal([data.style, data.displayName, data.product.title, (data.specs || {}).fabric, (data.specs || {}).cat].concat(nativeColours(data).map(function (item) { return item.name; })).join(' ')).includes(query));
      card.hidden = !matches; if (matches) visible++;
      if (!matches && card.classList.contains('open')) { card.classList.remove('open'); var toggle = card.querySelector('[data-card-toggle]'); toggle.setAttribute('aria-expanded', 'false'); }
    });
    cards.sort(function (a, b) {
      var result = 0;
      if (sort === 'weight') { var rank = function (node) { return Number(node.dataset.gsm) ? 0 : Number(node.dataset.oz) ? 1 : 2; }; result = rank(a) - rank(b) || (rank(a) === 0 ? Number(b.dataset.gsm) - Number(a.dataset.gsm) : rank(a) === 1 ? Number(b.dataset.oz) - Number(a.dataset.oz) : 0); }
      else if (sort === 'colours') result = Number(b.dataset.colourCount) - Number(a.dataset.colourCount);
      else if (sort === 'pack') result = Number(a.dataset.casePack) - Number(b.dataset.casePack);
      else if (sort === 'style') result = a.dataset.style.localeCompare(b.dataset.style);
      else if (sort === 'price') { var cost = function (card) { var data = dataFor(card); return data.quoteOnly ? Infinity : Number(card.dataset.price) / (mode === 'wholesale' ? data.packSize : 1); }; result = cost(a) - cost(b); }
      return result || Number(a.dataset.pos) - Number(b.dataset.pos);
    });
    var grid = host.querySelector('[data-catalogue-grid]'); cards.forEach(function (card) { grid.appendChild(card); });
    var count = host.querySelector('[data-catalogue-count]'); if (count) count.textContent = visible + ' OF ' + cards.length + ' STYLES';
    all('[data-brand-style-count]', host).forEach(function (node) { node.textContent = visible; });
    var summary = host.querySelector('[data-category-summary]');
    if (summary) {
      var dataItems = cards.filter(function (card) { return !card.hidden; }).map(dataFor), drink = cards.length > 0 && cards.every(function (card) { return (dataFor(card).specs || {}).kind === 'drink'; });
      if (drink) { var volumes = dataItems.flatMap(function (data) { return (data.specs || {}).ml || []; }).map(Number).filter(Number.isFinite).sort(function (a, b) { return a - b; }); summary.textContent = dataItems.length + ' product' + (dataItems.length === 1 ? '' : 's') + (volumes.length ? ', ' + volumes[0] + '–' + volumes[volumes.length - 1] + ' ml.' : '.') + ' Quoted by the carton.'; }
      else summary.textContent = dataItems.length + ' style' + (dataItems.length === 1 ? '' : 's') + ', ' + dataItems.reduce(function (total, data) { return total + nativeColours(data).length; }, 0) + ' colourways.';
    }
    var empty = host.querySelector('[data-catalogue-empty]'); if (empty) empty.hidden = visible > 0;
    all('[data-filter-colour]', host).forEach(function (button) { button.setAttribute('aria-pressed', String(familyKey(button.dataset.filterColour) === colour)); });
    all('[data-filter-size]', host).forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.filterSize === size)); });
    var chips = host.querySelector('[data-catalogue-chips]');
    if (chips) {
      all('[data-clear-filter], [data-generated-chip]', chips).forEach(function (node) { node.remove(); });
      [['Colour', host.dataset.filterColour], ['Size', size], ['Query', host.dataset.filterQuery]].forEach(function (entry) {
        if (!entry[1]) return;
        var routeOwned = entry[0] === 'Colour' && host.hasAttribute('data-colour-directory'), button = document.createElement(routeOwned ? 'a' : 'button');
        button.className = routeOwned ? 'chipf path' : 'chipf'; button.dataset.generatedChip = '';
        if (routeOwned) button.href = root + 'collections/bns-catalogue'; else { button.type = 'button'; button.dataset.clearFilter = entry[0]; }
        button.textContent = entry[1] + ' ×'; chips.appendChild(button);
      });
      if (chips.children.length) {
        var path = chips.querySelector('.path'), clear = document.createElement(path ? 'a' : 'button'); clear.className = 'clearall'; clear.dataset.generatedChip = ''; clear.textContent = 'Clear all';
        if (path) clear.href = root + 'collections/bns-catalogue'; else { clear.type = 'button'; clear.dataset.clearFilter = 'All'; }
        chips.appendChild(clear);
      }
      chips.hidden = chips.children.length === 0;
    }
    if (host.hasAttribute('data-colour-directory')) {
      host.querySelector('[data-colour-families]').hidden = !!colour; host.querySelector('[data-colour-results]').hidden = !colour;
      var family = all('[data-filter-colour]', host).find(function (button) { return familyKey(button.dataset.filterColour) === colour; });
      var display = family ? family.dataset.filterColour : host.dataset.filterColour;
      host.querySelector('[data-colour-heading]').textContent = colour ? display : 'Shop by colour';
      var description = host.querySelector('[data-colour-description]'); if (!description.dataset.default) description.dataset.default = description.textContent;
      description.textContent = colour ? visible + ' styles stocked in ' + display.toLowerCase() + '.' : description.dataset.default;
    }
    scheduleCardHeights();
  }
  async function loadRemaining(host, quick) {
    var selector = quick ? '[data-quick-next]' : '[data-catalogue-next]', next = host.querySelector(selector);
    if (!next || host.dataset.loading === 'true') return;
    host.dataset.loading = 'true';
    var visited = new Set();
    try {
      while (next && host.isConnected) {
        var url = new URL(next.href, location.origin); url.searchParams.set('section_id', host.dataset.sectionId);
        if (visited.has(url.href)) throw new Error('Catalogue pagination repeated.');
        var response = await fetch(url.href, { credentials: 'same-origin' }); if (!response.ok) throw new Error('Catalogue could not load.');
        var parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        var source = parsed.querySelector(quick ? '[data-quick-catalogue]' : '[data-catalogue-grid]');
        if (!source) throw new Error('Catalogue response is incomplete.');
        var destination = host.querySelector(quick ? '[data-quick-catalogue]' : '[data-catalogue-grid]');
        var known = new Set(Array.from(destination.children).map(function (node) { var data = dataFor(node); return data && String(data.product.id); }));
        visited.add(url.href);
        Array.from(source.children).forEach(function (node) {
          var incoming = dataFor(node); if (!incoming || known.has(String(incoming.product.id))) return; known.add(String(incoming.product.id));
          destination.appendChild(node);
          if (!quick) { all('[data-matrix-form] input[data-variant-id]', node).forEach(function (input) { input.dataset.quantityStep = dataFor(node).step; }); var matrix = node.querySelector('[data-matrix-form]'); if (matrix) { seedMatrix(matrix); recalcMatrix(matrix); } }
        });
        var following = parsed.querySelector(selector); next.remove(); next = following;
        if (next) host.appendChild(next);
      }
    } catch (error) { if (next) { next.hidden = false; next.textContent = quick ? 'LOAD MORE STYLES' : 'MORE STYLES'; } }
    finally {
      delete host.dataset.loading;
      if (host.isConnected) {
        if (quick) all('[data-quick-style]', host).forEach(function (select) { var chosen = select.value; select.replaceChildren(new Option('Style…', '')); quickProducts(host).forEach(function (data) { select.add(new Option(data.style + ' — ' + data.displayName, String(data.product.id))); }); select.value = chosen; });
        else initCatalogue(host);
        paint(host);
      }
    }
  }

  // "You may also like" under a product: Shopify's related picks (purchase history and similarity), minus styles already shown above it.
  function loadRecommendations(scope) {
    all('[data-recommendations]', scope).forEach(async function (host) {
      if (host.dataset.loaded) return;
      host.dataset.loaded = 'true';
      try {
        var response = await fetch(host.dataset.recommendations, { credentials: 'same-origin' });
        if (!response.ok) return;
        var parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        var path = function (link) { return new URL(link.getAttribute('href'), location.origin).pathname; };
        var shown = new Set(all('a[href*="/products/"]', host.parentElement).map(path));
        shown.add(location.pathname);
        var cards = all('.bns-product-card', parsed).filter(function (card) { var link = card.querySelector('a[href*="/products/"]'); return link && !shown.has(path(link)); }).slice(0, 4);
        if (!cards.length) return;
        var grid = host.querySelector('.rowgrid');
        cards.forEach(function (card) { grid.appendChild(card); });
        host.hidden = false;
        init(host);
      } catch (error) { /* optional strip: the page works without it */ }
    });
  }

  function init(scope) {
    scope = scope || document;
    loadRecommendations(scope);
    paint(scope);
    var galleries = all('[data-gallery]', scope);
    if (scope.matches && scope.matches('[data-gallery]')) galleries.unshift(scope);
    galleries.forEach(function (gallery) { showGalleryMedia(gallery, gallery.dataset.activeMedia); });
    var sections = all('[data-product-section]', scope);
    if (scope.matches && scope.matches('[data-product-section]')) sections.unshift(scope);
    sections.forEach(function (section) {
      var data = dataFor(section);
      if (!data) return;
      if (hasCatalogueAuthority(data)) {
        all('[data-option-value], [data-card-colour], [data-wholesale-colour]', section).forEach(function (button) {
          var index = button.hasAttribute('data-option-value') ? Number(button.dataset.optionIndex) : optionNames(data).findIndex(function (name) { return name === 'color' || name === 'colour'; });
          var value = button.dataset.optionValue || button.dataset.cardColour || button.dataset.wholesaleColour;
          if (!data.product.variants.some(function (variant) { return exactColour(variant.options[index]) === exactColour(value); })) button.remove();
        });
        all('[data-variant-select] option', section).forEach(function (option) { if (!data.product.variants.some(function (variant) { return String(variant.id) === option.value; })) option.remove(); });
        all('[data-matrix-form] input[data-variant-id]', section).forEach(function (input) { if (!data.product.variants.some(function (variant) { return String(variant.id) === input.dataset.variantId && variant.available; })) { input.disabled = true; input.value = '0'; } });
      }
      if (hasCatalogueAuthority(data)) {
        var ci = optionNames(data).findIndex(function (name) { return name === 'color' || name === 'colour'; });
        if (ci >= 0 && !section.querySelector('[data-option-index="' + ci + '"][aria-current="true"]')) {
          var first = section.querySelector('[data-option-index="' + ci + '"]');
          if (first) first.setAttribute('aria-current', 'true');
        }
      }
      var picker = section.querySelector('[data-option-picker]');
      if (picker) picker.hidden = false;
      var retailForm = section.querySelector('[data-retail-form]');
      if (retailForm) retailForm.classList.add('bns-enhanced');
      all('[data-matrix-form] input[data-variant-id]', section).forEach(function (input) { if (input.closest('[data-product-section]') === section) input.dataset.quantityStep = data.step; });
      var select = section.querySelector('[data-variant-select]');
      if (select && !retailForm.dataset.initialized) {
        retailForm.dataset.initialized = 'true';
        var requested = new URLSearchParams(location.search).get('variant');
        var variant = data.product.variants.find(function (item) { return String(item.id) === (requested || select.value); });
        if (requested && !variant && data.legacyVariantMap && Object.prototype.hasOwnProperty.call(data.legacyVariantMap, requested)) {
          variant = data.product.variants.find(function (item) { return String(item.id) === data.legacyVariantMap[requested]; });
        }
        if (requested && !variant) {
          selectVariant(section, null, true, false);
          var cleanUrl = new URL(location.href); cleanUrl.searchParams.delete('variant'); history.replaceState({}, '', cleanUrl);
          message(retailForm, 'The linked option is unavailable for this item. Review the current colours and sizes.');
        }
        else if (requested || !section.hasAttribute('data-product-page') || data.product.variants.length === 1) selectVariant(section, variant, false, !!requested || !data.isApparel || !section.hasAttribute('data-product-page'));
        else selectVariant(section, null, true, false);
      }
      if (data.isApparel && section.hasAttribute('data-product-page') && section.dataset.galleryColour == null) {
        var firstColour = section.querySelector('[data-option-index="' + optionNames(data).findIndex(function (name) { return name === 'color' || name === 'colour'; }) + '"][aria-current="true"]') || section.querySelector('[data-wholesale-colour][aria-current="true"]');
        if (firstColour) showProductColour(section, data, firstColour.dataset.optionValue || firstColour.dataset.wholesaleColour, null, true);
        else if (hasCatalogueAuthority(data) && optionNames(data).every(function (name) { return name !== 'color' && name !== 'colour'; })) showProductColour(section, data, '', data.product.variants[0], true);
      }
      all('[data-matrix-form]', section).filter(function (form) { return form.closest('[data-product-section]') === section; }).forEach(function (form) { seedMatrix(form); recalcMatrix(form); });
    });
    all('[data-quick-order]', scope).forEach(function (host) { if (!host.querySelector('[data-quick-row]')) newQuickRow(host); recalcQuick(host.querySelector('[data-quick-form]')); loadRemaining(host, true); });
    all('[data-catalogue]', scope).forEach(function (host) { initCatalogue(host); loadRemaining(host, false); });
    initLogin(scope);
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest('button, a');
    if (!target) return;
    var modeName = target.dataset.setMode || target.dataset.bnsMode;
    if (modeName) {
      event.preventDefault();
      mode = modeName === 'wholesale' ? 'wholesale' : 'retail';
      try { localStorage.setItem('bns_mode', mode); } catch (error) { /* Storage is optional. */ }
      paint();
      if (latestCart) paintCount(latestCart);
      var runBar = document.getElementById('runbar'); if (runBar) runBar.classList.remove('on');
      all('[data-catalogue]').forEach(filterCatalogue);
      all('[data-quick-form]').forEach(recalcQuick);
      document.dispatchEvent(new CustomEvent('bns:modechange', { detail: { mode: mode } }));
      if (!(window.Shopify && window.Shopify.designMode) && location.pathname !== root) location.assign(root);
      return;
    }
    if (target.hasAttribute('data-card-toggle')) {
      var card = target.closest('.card'), open = !card.classList.contains('open');
      all('.bns-product-card.open').forEach(function (other) { other.classList.remove('open'); var button = other.querySelector('[data-card-toggle]'); button.setAttribute('aria-expanded', 'false'); button.querySelector('.lbl').textContent = 'OPEN SIZE RUN'; });
      card.classList.toggle('open', open); target.setAttribute('aria-expanded', String(open)); target.querySelector('.lbl').textContent = open ? 'CLOSE SIZE RUN' : 'OPEN SIZE RUN';
      scheduleCardHeights();
      var bar = document.getElementById('runbar'); if (bar) bar.classList.remove('on');
      if (open) { recalcMatrix(card.querySelector('[data-matrix-form]')); if (window.gsap && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) gsap.fromTo(all('tbody tr', card), { opacity: 0, y: 8 }, { opacity: 1, y: 0, duration: .3, stagger: .025, clearProps: 'all' }); }
    }
    if (target.hasAttribute('data-run-add') && runForm) runForm.requestSubmit();
    if (target.hasAttribute('data-print-spec')) window.print();
    var catalogue = target.closest('[data-catalogue]');
    if (catalogue && (target.hasAttribute('data-filter-colour') || target.hasAttribute('data-filter-size') || target.hasAttribute('data-clear-filter'))) {
      var field = target.hasAttribute('data-filter-colour') ? 'Colour' : target.hasAttribute('data-filter-size') ? 'Size' : target.dataset.clearFilter;
      var value = target.dataset['filter' + field] || '';
      if (field === 'All') { catalogue.dataset.filterColour = ''; catalogue.dataset.filterSize = ''; catalogue.dataset.filterQuery = ''; }
      else catalogue.dataset['filter' + field] = catalogue.dataset['filter' + field] === value ? '' : value;
      filterCatalogue(catalogue);
    }
    var section = target.closest('[data-product-section]');
    if (section && target.hasAttribute('data-card-colour')) {
      var cardData = dataFor(section), cardColour = target.dataset.cardColour;
      if (cardData && cardData.isApparel) {
        var cardSource = colourImage(cardData, cardColour), shot = section.querySelector('a.shot'), cardImage = shot && shot.querySelector('img.flat'), cardStatus = shot && shot.querySelector('[data-card-photo-status]');
        section.classList.add('bns-card-colour-selected');
        all('[data-card-colour]', section).forEach(function (button) { button.setAttribute('aria-pressed', String(button === target)); });
        if (cardImage) {
          if (!cardImage.dataset.originalSrc) { cardImage.dataset.originalSrc = cardImage.src; cardImage.dataset.originalSrcset = cardImage.getAttribute('srcset') || ''; cardImage.dataset.originalAlt = cardImage.alt; }
          cardImage.hidden = !cardSource; cardImage.removeAttribute('srcset');
          if (cardSource) { cardImage.src = cardSource; cardImage.alt = nativeImage(cardData, cardSource).alt; }
          else { cardImage.src = cardImage.dataset.originalSrc; cardImage.alt = cardImage.dataset.originalAlt; if (cardImage.dataset.originalSrcset) cardImage.setAttribute('srcset', cardImage.dataset.originalSrcset); }
        }
        if (cardStatus) { cardStatus.hidden = !!cardSource; cardStatus.textContent = cardSource ? '' : 'A photo for ' + cardColour + ' is not available yet.'; }
        var colourIndex = optionNames(cardData).findIndex(function (name) { return name === 'color' || name === 'colour'; });
        var colourVariants = cardData.product.variants.filter(function (variant) { return exactColour(variant.options[colourIndex]) === exactColour(cardColour); });
        var linkedVariant = colourVariants.find(function (variant) { return variant.available; }) || colourVariants[0];
        if (linkedVariant) all('a.shot, .bns-card-name a, a.style, a.deploy', section).forEach(function (link) { var url = new URL(link.href, location.origin); url.searchParams.set('variant', linkedVariant.id); link.href = url.pathname + url.search + url.hash; });
      }
    }
    if (section && target.hasAttribute('data-wholesale-colour')) {
      var data = dataFor(section), colour = target.dataset.wholesaleColour, source = colourImage(data, colour), gallery = section.querySelector('.gal[data-gallery]');
      all('[data-wholesale-colour]', section).forEach(function (button) { button.setAttribute('aria-current', String(button === target)); });
      section.querySelector('[data-wholesale-colour-label]').textContent = colour.toUpperCase();
      if (gallery && data.isApparel) {
        showProductColour(section, data, colour);
      } else if (source && gallery) { var primary = gallery.querySelector('[data-media-id]:not([hidden]) img'); if (primary) { primary.src = source; primary.removeAttribute('srcset'); } all('[data-gallery-target]', gallery).forEach(function (button) { button.setAttribute('aria-current', 'false'); }); }
      all('[data-matrix-colour]', section).forEach(function (row) { var hit = normal(row.dataset.matrixColour) === normal(colour); row.classList.toggle('hit', hit); if (hit) { var rect = row.closest('.mtxwrap').getBoundingClientRect(); if (rect.top < innerHeight && rect.bottom > 0) row.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } });
    }
    var gallery = target.closest('[data-gallery]');
    if (gallery && target.hasAttribute('data-gallery-target')) { event.preventDefault(); showGalleryMedia(gallery, target.dataset.galleryTarget); }
    if (gallery && target.hasAttribute('data-gallery-step')) {
      var mediaItems = galleryItems(gallery);
      var activeIndex = mediaItems.findIndex(function (node) { return node.dataset.mediaId === gallery.dataset.activeMedia; });
      var nextIndex = (activeIndex + Number(target.dataset.galleryStep) + mediaItems.length) % mediaItems.length;
      showGalleryMedia(gallery, mediaItems[nextIndex].dataset.mediaId);
    }
    if (section && target.hasAttribute('data-option-value')) {
      var data = dataFor(section);
      all('[data-option-index="' + target.dataset.optionIndex + '"]', section).forEach(function (button) { button.setAttribute('aria-current', String(button === target)); });
      var values = optionNames(data).map(function (name, index) { var values = Array.from(new Set(data.product.variants.map(function (variant) { return variant.options[index]; }))); return hasCatalogueAuthority(data) && name !== 'size' && values.length === 1 ? values[0] : undefined; }); all('[data-option-value][aria-current="true"]', section.querySelector('[data-retail-form]')).forEach(function (button) { values[Number(button.dataset.optionIndex)] = button.dataset.optionValue; });
      var chosen = data.product.variants.find(function (variant) { return variant.options.every(function (value, index) { return value === values[index]; }); });
      var optionName = optionNames(data)[Number(target.dataset.optionIndex)];
      selectVariant(section, chosen, values.filter(Boolean).length < optionNames(data).length, optionName === 'color' || optionName === 'colour');
    }
    var matrix = target.closest('[data-matrix-form]');
    if (matrix && target.hasAttribute('data-fill-row')) fillRow(target.closest('tr'), matrix);
    if (matrix && target.hasAttribute('data-curve')) {
      all('[data-curve]', matrix).forEach(function (button) { button.setAttribute('aria-pressed', String(button === target)); });
      all('[data-curved="true"]', matrix).forEach(function (row) { fillRow(row, matrix); });
    }
    if (target.hasAttribute('data-cart-remove')) {
      event.preventDefault();
      updateCart(target.closest('[data-cart-section]'), { id: target.closest('[data-line-key]').dataset.lineKey, quantity: 0 });
    }
    var quickHost = target.closest('[data-quick-order]');
    if (quickHost && target.hasAttribute('data-quick-new')) newQuickRow(quickHost).querySelector('select').focus();
    if (quickHost && target.hasAttribute('data-quick-remove')) { target.closest('[data-quick-row]').remove(); recalcQuick(quickHost.querySelector('[data-quick-form]')); }
    if (quickHost && target.hasAttribute('data-quick-import')) importQuick(quickHost, quickHost.querySelector('[data-quick-paste]').value);

  });
  document.addEventListener('input', function (event) {
    var target = event.target;
    if (target.matches('[data-retail-quantity], [data-cart-quantity], [data-quick-quantity], [data-matrix-form] input[data-variant-id]')) target.removeAttribute('aria-invalid');
    if (target.hasAttribute('data-retail-quantity')) quantityValue(target, 1, 1, false, false);
    if (target.hasAttribute('data-cart-quantity')) quantityValue(target, 0, 1, false, false);
    var matrix = target.closest('[data-matrix-form]');
    if (matrix && target.matches('input[data-variant-id]')) { delete target.closest('tr').dataset.curved; recalcMatrix(matrix); }
    var quick = target.closest('[data-quick-form]');
    if (quick) recalcQuick(quick);
    if (target.hasAttribute('data-colour-search')) {
      var directory = target.closest('[data-colour-directory]'); directory.dataset.filterColour = target.value; filterCatalogue(directory);
    }
  });
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target.hasAttribute('data-retail-quantity')) { quantityValue(target, 1, 1, true, false); target.reportValidity(); }
    if (target.matches('[data-matrix-form] input[data-variant-id]')) { recalcMatrix(target.closest('[data-matrix-form]'), true); target.reportValidity(); }
    if (target.hasAttribute('data-variant-select')) {
      var section = target.closest('[data-product-section]'), data = dataFor(section);
      var variant = data.product.variants.find(function (item) { return String(item.id) === target.value; });
      var colourIndex = optionNames(data).findIndex(function (name) { return name === 'color' || name === 'colour'; });
      selectVariant(section, variant, false, !data.isApparel || !variant || exactColour(variant.options[colourIndex]) !== exactColour(section.dataset.galleryColour));
    }
    if (target.closest('[data-quick-row]')) { recalcQuick(target.closest('[data-quick-form]'), target.hasAttribute('data-quick-quantity')); if (target.hasAttribute('data-quick-quantity')) target.reportValidity(); }
    if (target.hasAttribute('data-catalogue-sort')) filterCatalogue(target.closest('[data-catalogue]'));
    if (target.hasAttribute('data-quick-file')) {
      var file = target.files && target.files[0], host = target.closest('[data-quick-order]');
      if (!file) return;
      if (file.size > 1024 * 1024) { host.querySelector('[data-import-status]').textContent = 'Upload a CSV smaller than 1 MB.'; target.value = ''; return; }
      file.text().then(function (text) { if (host.isConnected) importQuick(host, text); }).catch(function () { if (host.isConnected) host.querySelector('[data-import-status]').textContent = 'This file could not be read.'; });
      target.value = '';
    }
    if (target.hasAttribute('data-cart-quantity')) commitCartQuantity(target);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' && event.target.hasAttribute('data-cart-quantity')) { event.preventDefault(); commitCartQuantity(event.target); return; }
    if (event.key === 'Enter' && event.target.matches('[data-matrix-form] input[data-variant-id]')) { event.preventDefault(); recalcMatrix(event.target.closest('[data-matrix-form]'), true); event.target.reportValidity(); return; }
    var gallery = event.target.closest('[data-gallery]');
    if (gallery && event.target.hasAttribute('data-gallery-target') && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
      event.preventDefault();
      var media = galleryItems(gallery);
      var current = media.findIndex(function (node) { return node.dataset.mediaId === gallery.dataset.activeMedia; });
      var next = event.key === 'Home' ? 0 : event.key === 'End' ? media.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + media.length) % media.length;
      showGalleryMedia(gallery, media[next].dataset.mediaId, true);
      return;
    }
    var row = event.target.closest('[data-quick-row]');
    if (!row) return;
    var fields = all('select, input, button', row), index = fields.indexOf(event.target);
    if (event.key === 'Tab' && !event.shiftKey && index === fields.length - 1 && !row.nextElementSibling) newQuickRow(row.closest('[data-quick-order]'));
    if (event.key !== 'Enter' || !event.target.matches('input, select')) return;
    event.preventDefault();
    if (event.target.hasAttribute('data-quick-quantity')) { recalcQuick(row.closest('[data-quick-form]'), true); if (!event.target.reportValidity()) return; }
    if (index < 3) fields[index + 1].focus();
    else (row.nextElementSibling || newQuickRow(row.closest('[data-quick-order]'))).querySelector('select').focus();
  });
  document.addEventListener('reset', function (event) {
    var form = event.target;
    requestAnimationFrame(function () {
      if (!form.isConnected) return;
      if (form.matches('[data-matrix-form]')) { all('[data-curved]', form).forEach(function (row) { delete row.dataset.curved; }); recalcMatrix(form); }
      if (form.matches('[data-quick-form]')) recalcQuick(form);
    });
  });
  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (form.matches('[data-retail-form]')) {
      event.preventDefault();
      var data = dataFor(form.closest('[data-product-section]'));
      var variant = data.product.variants.find(function (item) { return String(item.id) === form.querySelector('[data-variant-select]').value; });
      var quantity = quantityValue(form.querySelector('[data-retail-quantity]'), 1, 1, true, false);
      if (!variant || !variant.available || !quantity || data.quoteOnly) { message(form, variant ? 'Choose an available variant and quantity.' : 'Choose a size first.'); return; }
      await addItems(form, [{ id: variant.id, quantity: quantity }]);
      var currentVariant = data.product.variants.find(function (item) { return String(item.id) === form.querySelector('[data-variant-select]').value; });
      form.querySelector('[data-retail-add]').disabled = !currentVariant || !currentVariant.available;
    } else if (form.matches('[data-matrix-form]')) {
      event.preventDefault();
      recalcMatrix(form, true);
      if (!config.wholesale || !form.reportValidity()) return;
      var matrixData = dataFor(form.closest('[data-product-section]'));
      if (!matrixData || matrixData.quoteOnly) { message(form, 'This style requires a quote.'); return; }
      var items = all('input[data-variant-id]', form).filter(function (input) { return !input.disabled && Number(input.value) > 0; }).map(function (input) { return { id: Number(input.dataset.variantId), quantity: Number(input.value) / matrixData.packSize }; });
      await addItems(form, items); recalcMatrix(form);
    } else if (form.matches('[data-quick-form]')) {
      event.preventDefault();
      recalcQuick(form, true);
      if (!canPrice() || !form.reportValidity()) return;
      var quickItems = new Map();
      all('[data-quick-row]', form).forEach(function (row) {
        var input = row.querySelector('[data-quick-quantity]'), quantity = Number(input.value); if (input.disabled || !quantity) return;
        var id = Number(row.dataset.variantId), units = quantity / Number(row.dataset.packSize);
        quickItems.set(id, (quickItems.get(id) || 0) + units);
      });
      await addItems(form, Array.from(quickItems, function (entry) { return { id: entry[0], quantity: entry[1] }; }));
    } else if (form.matches('[data-cart-form]')) {
      if (all('[data-cart-line][data-catalogue-allowed="false"]', form).some(function (line) { return Number(line.querySelector('[data-cart-quantity]').value) > 0; })) { event.preventDefault(); message(form, 'Remove retired options and choose current catalogue options before checkout.'); return; }
      var updates = {};
      all('[data-cart-line]', form).forEach(function (line) { updates[line.dataset.lineKey] = quantityValue(line.querySelector('[data-cart-quantity]'), 0, 1, true, false); });
      if (Object.values(updates).some(function (quantity) { return quantity === null; }) || !form.reportValidity()) { event.preventDefault(); return; }
      if (!event.submitter || event.submitter.name !== 'checkout') { event.preventDefault(); updateCart(form.closest('[data-cart-section]'), { updates: updates }); }
    }
  });
  function trackZoom(event, toggle) {
    var box = event.target.closest('[data-zoom]'); if (!box || innerWidth < 700) return;
    var img = box.querySelector('[data-media-id]:not([hidden]) img'); if (!img) return;
    if (toggle) box.classList.toggle('zoomed'); else if (event.pointerType !== 'touch') box.classList.add('zoomed');
    var rect = box.getBoundingClientRect(); if (!rect.width || !rect.height) return;
    box.style.setProperty('--z', Math.max(1.8, Math.min(2.8, img.naturalWidth / rect.width)).toFixed(2));
    img.style.transformOrigin = Math.min(100, Math.max(0, (event.clientX - rect.left) / rect.width * 100)) + '% ' + Math.min(100, Math.max(0, (event.clientY - rect.top) / rect.height * 100)) + '%';
  }
  document.addEventListener('pointermove', function (event) { trackZoom(event, false); });
  document.addEventListener('pointerdown', function (event) { if (event.pointerType === 'touch') trackZoom(event, true); });
  document.addEventListener('pointerout', function (event) { var box = event.target.closest('[data-zoom]'); if (box && event.pointerType !== 'touch' && !box.contains(event.relatedTarget)) box.classList.remove('zoomed'); });
  document.addEventListener('keydown', function (event) { if (event.target.matches('[data-zoom]') && (event.key === 'Enter' || event.key === ' ')) { event.preventDefault(); event.target.classList.toggle('zoomed'); } });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { all('.rowgrid', event.target).forEach(function (grid) { if (cardGridObserver) cardGridObserver.unobserve(grid); grid.removeEventListener('load', scheduleCardHeights, true); cardGridWidths.delete(grid); }); if (runForm && event.target.contains(runForm)) { runForm = null; if (runObserver) runObserver.disconnect(); var bar = document.getElementById('runbar'); if (bar) bar.classList.remove('on'); } all('[data-product-section]', event.target).forEach(function (section) { productData.delete(section); }); });
  window.BNSCommerce = { init: init };
  init(document);
  refreshCount();
})();
